import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingStore } from "@tabler/icons-react";
import { TiendasDef } from "./TiendasDef";

export const TiendasHelpText = "* Aquí tiene toda la lista de las tiendas dadas de alta.";
export const TiendasIcon = IconBuildingStore;


export class Tiendas extends Entity<TiendasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new TiendasDef(), parentKeys);
        this.Form = import('./TiendasForm').then((module) => module.TiendasForm);
        this.Title = "Tiendas";
        //this.HelpText = "* Agregue aquí las Tiendas que pertenecen al Grupo. Al crear una tienda también podrá asignarle un Canal. Las Tiendas pueden pertenecer a una sola Empresa y a una sola Cadena.";
        this.HelpText = TiendasHelpText;
        this.Icon = TiendasIcon;  
    }
}